<template>
  <div class="container">
    <div class="caseBlanche">
      <img src="https://s.vipkidstatic.com/fe-static/vkshop-m/static/img/loading-icon.090949c9.png"/>
    </div>
  </div>
</template>

<script>
// 扫描二维码根据用户重定向到对应下单页面
import cookie from 'js-cookie'
import referralUri from '@/utils/_referral'
import { getRediract } from '@/api/qrcoderedirect'

export default {
  data () {
    return {
    }
  },
  created () {
    const channelId = this.$route.query.channelId || '14768740'
    const activityCode = this.$route.query.activityCode || ''
    const parentId = cookie.get('mbparentid')
    if (parentId) {
      this.getRediract(parentId)
    } else {
      cookie.remove('mbparentid')
      window.location.href = referralUri(channelId, activityCode)
    }
  },
  mounted () {
  },
  destroyed () {

  },
  methods: {
    getRediract (parentId) {
      getRediract({
        parentId
      }).then(res => {
        console.log(res)
        if (res.data) {
          window.location.replace(res.data)
          return
        }
        if (this.$route.query.grade === '1') {
          // console.log('https://mobile.vipkid.com.cn/shop/detail/1386?channel_id=14766962')
          window.location.replace('https://mobile.vipkid.com.cn/shop/detail/1386?channel_id=14766962')
        } else {
          // console.log('https://mobile.vipkid.com.cn/shop/detail/1385?channel_id=14766962')
          window.location.replace('https://mobile.vipkid.com.cn/shop/detail/1385?channel_id=14766962')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color : white;
  height : 100vh;
  width : 100vw;
  position : relative;
}
.caseBlanche{
  height  : 60px;
  width : 60px;
  position :absolute;
  top : 50%;
  left : 50%;
  transform: translate(-50%,-50%);
  display: block;
  img{
    position :absolute;
    top:0;
    left:0;
    height  : 60px;
    width : 60px;
    animation:rotate .7s linear infinite;
  }
}
@keyframes rotate{
  0%{
    transform:rotate(0deg)
  }to{
    transform:rotate(1turn)
  }
}
</style>
